<template>
	<div class="page-content">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item><span style="cursor: pointer;" @click="gotoSetting">系统设置</span></el-breadcrumb-item>
			<el-breadcrumb-item>品牌方活动价格设置</el-breadcrumb-item>
		</el-breadcrumb>

		<section class="seaerch-wrapper" style="border-radius: 12px;">
			<el-form class="search-form" style="margin-left: -30px;">
				<el-form-item label="平台" :label-width="formLabelWidth">
					<el-select v-model="platform" filterable clearable placeholder="请选择" size="small">
						<el-option v-for="item in platformList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动店铺" :label-width="formLabelWidth">
					<el-input placeholder="请输入" v-model="shopname" size="small" clearable></el-input>
				</el-form-item>
				<el-form-item label="活动产品" :label-width="formLabelWidth">
					<el-input placeholder="请输入" v-model="productname" size="small" clearable></el-input>
				</el-form-item>
				<el-form-item label="状态" :label-width="formLabelWidth">
					<el-select v-model="status" filterable clearable placeholder="请选择" size="small">
						<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动时间" :label-width="formLabelWidth">
					<el-date-picker size="small" v-model="timeDate" value-format="yyyy-MM-dd" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
				</el-form-item>
			</el-form>
		</section>

		<div class="brandPartyPage">
			<div class="downBtn">
				<el-button size="small" type="primary" @click="newAdd" icon="el-icon-plus">新增</el-button>
				<el-button size="small" @click="ediChange(2)">批量编辑</el-button>
				<el-button size="small" @click="onOpenDeleteDia(2)">批量删除</el-button>
				<el-button size="small" @click="downData" :loading="downLoading">下载数据</el-button>
				<el-button size="small" @click="batchImport">批量导入</el-button>
				<el-button size="small" @click="downloadTemplate">下载模板</el-button>
			</div>
			<div class="prompt">
				<i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
				共<span class="promptFont">{{ totalNum }}</span>项,已选择<span class="promptFont">{{ openNumber }}</span>项
				<span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
				<span class="promptFont">/</span>
				<span class="promptFont2" @click="toggleSelection()">取消勾选</span>
			</div>
			<el-table ref="multipleTable" :data="tableData" style="width: 100%"
				@selection-change="handleSelectionChange" v-loading="tableLoading">
				<el-table-column type="selection" width="60" fixed>
				</el-table-column>
				<el-table-column label="序号" width="80">
					<template slot-scope="scope">
						{{ scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column prop="shopname" label="店铺名称">
				</el-table-column>
				<el-table-column prop="productname" label="产品信息">
				</el-table-column>
				<el-table-column prop="productfield" label="产品字段">
				</el-table-column>
				<el-table-column prop="price" label="活动标价">
				</el-table-column>
				<el-table-column prop="availableprice" label="活动到手价">
				</el-table-column>
				<el-table-column label="活动时间" width="400">
					<template slot-scope="scope">
						{{ scope.row.starttime | fullTime }} - {{ scope.row.endtime | fullTime }}
						<i class="el-icon-error" style="padding-left: 8px;" v-if="scope.row.status == 1"></i>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="ediChange(1, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="onOpenDeleteDia(1, scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-if="tableData && tableData.length > 0" :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
				:total="totalElements" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
			</pagination>
		</div>
		<!-- 删除 -->
		<el-dialog title="提示" :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" id="dialog">
			<div style="display: flex;width: 100%;justify-content:center;">
				<i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
				<div>
					<div style="font-size: 16px;">
						你确认要删除<span>{{ delType }}</span>信息吗？
					</div>
					<div style="font-size: 14px;">删除后
						<span style="color: #e90e24;font-size: 14px;">
							活动价格信息将会被彻底删除
						</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="delectCampaignSettingprice" size="small" :loading="ficationLoading">确
					定</el-button>
				<el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 编辑 -->
		<el-dialog title="编辑" :visible.sync="EditShow" :close-on-click-modal="false" width="640px" id="dialog">
			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
				<div class="seaerch-wrapper">
					<el-form label-width="100px">
						<el-form-item label="店铺名称" v-if="ediType != 'checkAll'">
							<el-input placeholder="请输入" v-model="editordata.shopname" size="small" disabled></el-input>
						</el-form-item>
						<el-form-item label="产品信息" v-if="ediType != 'checkAll'">
							<el-input placeholder="请输入" v-model="editordata.productname" size="small"
								disabled></el-input>
						</el-form-item>
						<el-form-item label="活动标价">
							<el-input placeholder="请输入" v-model="editordata.price" size="small"
								type="number"></el-input>
						</el-form-item>
						<el-form-item label="活动到手价">
							<el-input placeholder="请输入" v-model="editordata.availableprice" size="small"
								type="number"></el-input>
						</el-form-item>
						<el-form-item label="活动时间">
							<el-date-picker style="width: 440px;" size="small" v-model="editorTime"
								value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-form>
				</div>
			</el-row>
			<span slot="footer">
				<el-button size="small" @click="updateCampaignSettingprice" :loading="notifyLoading" type="primary">确
					定</el-button>
				<el-button size="small" @click="EditShow = false">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="批量导入" :visible.sync="batchShow" :close-on-click-modal="false" width="465px" id="dialog">
			<uploadBean @uploadBeanData="uploadBeanData" :uploadChange="uploadChange"></uploadBean>
			<span slot="footer">
				<el-button size="small" @click="batchShow = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import axios from "axios";
import pagination from "../../components/dataTable/pagination";
import uploadBean from "@/views/NotificationPublic/uploadBean";
export default {
	data() {
		return {
			currentPage: 0,
			totalElements: 0,
			timeDate: [],
			tableLoading: false,
			tableData: [],
			totalNum: 0,
			openNumber: 0,
			formLabelWidth: '100px',
			platform: '',
			shopname: '',
			productname: '',
			status: '',
			statusList: [
				{ value: 0, label: '没过期' },
				{ value: 1, label: '已过期' },
			],
			platformList: [
				{ value: 'TB', label: '淘宝' },
				{ value: 'TM', label: '天猫' },
				{ value: 'JD', label: '京东' },
				{ value: 'SN', label: '苏宁' },
				{ value: '1688', label: '1688' },
				{ value: 'DD', label: '当当' },
				{ value: 'PDD', label: '拼多多' },
			],
			downLoading: false,
			multipleSelection: [],
			tableIds: '',
			pageNo: 1,
			pageSize: 10,
			delIds: '',
			ficationLoading: false,
			delType: '',
			deleteShow: false,
			delType: '',
			EditShow: false,
			editordata: {
				price: '',
				availableprice: '',
			},
			editorTime: [],
			notifyLoading: false,
			ediType: '',
			batchShow: false,
			uploadChange: '4',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < (Date.now() - 1000 * 60 * 60 * 24);
				}
			},
		}
	},
	components: {
		pagination, uploadBean
	},
	mounted() {
		this.theQuery();
	},
	methods: {
		downloadTemplate() {
			window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E5%93%81%E7%89%8C%E6%96%B9%E6%B4%BB%E5%8A%A8%E4%BB%B7%E6%A0%BC%E8%AE%BE%E7%BD%AE%E6%A8%A1%E6%9D%BF.xlsx ', '_blank'); // 新开窗口
		},
		// 组件获取表格导入的数据
		uploadBeanData(val) {
			let that = this
			this.$message({
				message: '共计导入' + val.length + '条',
				type: 'success'
			});
			axios({
				method: 'post',
				url: 'hcm/campaignSettingprice/validationCampaignSettingprice ',
				headers: {
					'Content-type': 'application/json;charset=UTF-8'
				},
				data: val,
				timeout: 60 * 1000 * 50
			}).then(function (response) {
				if (response.data.status == "10000") {
					that.$message({
						message: '添加成功',
						type: 'success'
					});
					that.batchShow = false
				} else {
					that.$message.error(response.data.message)
				}
			}).catch(err => {
				this.$message.error('接口异常');
			});
		},
		// 编辑
		ediChange(e, data) {
			if (e == 1) {
				this.ediType = data.id
				this.editordata = data
				this.editorTime = []
				this.editorTime.push(this.$options.filters["fullTime"](data.starttime).substring(0, 10))
				this.editorTime.push(this.$options.filters["fullTime"](data.endtime).substring(0, 10))
			} else {
				if (this.multipleSelection.length == 0) {
					this.$message({
						message: '请选择数据',
						type: 'warning'
					});
					return
				}
				this.editordata.price = ''
				this.editordata.availableprice = ''
				this.editorTime = []
				this.ediType = 'checkAll'
			}
			this.EditShow = true
		},
		// 确认编辑
		updateCampaignSettingprice() {
			if (!this.editordata.price && this.editorTime.length == 0) {
				this.$message({
					message: '请填写活动价或者选择活动时间',
					type: 'warning'
				});
				return
			}
			console.log(this.editordata)
			this.notifyLoading = true
			let params = {
				ids: this.ediType,
			}
			if (this.editordata.price) {
				params.price = this.editordata.price
			} else {
				params.price = 0
			}
			if (this.editordata.availableprice) {
				params.availableprice = this.editordata.availableprice
			} else {
				params.availableprice = 0
			}
			if (this.editorTime.length != 0 && this.editorTime[0]) {
				params.starttimea = this.editorTime[0] + " 00:00:00"
			}
			if (this.editorTime.length != 0 && this.editorTime[1]) {
				params.endtimeb = this.editorTime[1] + " 23:59:59"
			}
			fetch({
				url: "hcm/campaignSettingprice/updateCampaignSettingprice ",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.ediType = ''
					this.notifyLoading = false
					this.EditShow = false
					this.$message({
						message: '成功',
						type: 'success'
					});
					this.theQuery();
				} else {
					this.$message.error(res.message);
				}
			})
		},
		// 删除
		onOpenDeleteDia(e, ids) {
			this.delIds = ''
			if (ids && e == 1) {
				this.delType = '该'
				this.delIds = ids
			} else if (this.checkAll == 2 && e == 2) {
				this.delType = '全部'
				this.delIds = "checkAll"
			} else {
				this.delType = this.openNumber + '条'
				let arrIds = []
				for (let i in this.multipleSelection) {
					arrIds.push(this.multipleSelection[i].id)
				}
				this.delIds = arrIds.join(',')
			}
			if (this.delIds == '' || this.openNumber == 0 && e != 1) {
				this.$message({
					message: '没有选中项',
					type: 'warning'
				});
				return
			}
			this.deleteShow = true
		},
		// 确认删除
		delectCampaignSettingprice() {
			this.ficationLoading = true
			let params = {
				ids: this.delIds,
			}
			if (this.platform) {
				params.platform = this.platform
			}
			if (this.shopname) {
				params.shopname = this.shopname
			}
			if (this.productname) {
				params.productname = this.productname
			}
			if (this.status || this.status == 0) {
				params.status = this.status
			}
			if (this.timeDate && this.timeDate.length != 0) {
				params.starttime = this.timeDate[0] + ' 00:00:00'
				params.endtime = this.timeDate[1] + ' 23:59:59'
			}
			fetch({
				url: "hcm/campaignSettingprice/delectCampaignSettingprice",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.ficationLoading = false
					this.deleteShow = false
					this.$message({
						message: '成功',
						type: 'success'
					});
					this.openNumber = 0
					this.theQuery();
				} else {
					this.$message.error(res.message);
				}
			})
		},
		// 取消删除
		delCancel() {
			this.deleteShow = false
			this.delType = ''
			this.checkAll = ''
			this.delIds = ''
		},
		//每页
		handleSizeChange(val) {
			this.pageSize = val;
			this.theQuery();
		},
		//当前页
		handleCurrentChange(val) {
			this.pageNo = val;
			this.theQuery();
		},
		// 数据源
		theQuery() {
			let params = {
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			}
			if (this.platform) {
				params.platform = this.platform
			}
			if (this.shopname) {
				params.shopname = this.shopname
			}
			if (this.productname) {
				params.productname = this.productname
			}
			if (this.status || this.status == 0) {
				params.status = this.status
			}
			if (this.timeDate && this.timeDate.length != 0) {
				params.starttime = this.timeDate[0] + ' 00:00:00'
				params.endtime = this.timeDate[1] + ' 23:59:59'
			}
			fetch({
				url: "hcm/campaignSettingprice/getCampaignSettingpricelist",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.tableData = res.data.content
					this.totalElements = res.data.totalElements
					this.totalNum = res.data.totalElements
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			})
		},
		// 跳转到上一级
		gotoSetting() {
			this.$router.push('/systemSetupList/systemSetup');
		},
		// 全选/取消全选
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleAllSelection(row);
					this.openNumber = this.totalNum
					this.checkAll = 2
				});
			} else {
				this.$refs.multipleTable.clearSelection();
				this.checkAll = 1
				this.openNumber = 0
			}
		},
		// table自带方法
		// handleSelectionChange(val) {
		// 	if (this.checkAll != 2) {
		// 		this.openNumber = val.length;
		// 		this.multipleSelection = val;
		// 	}
		// },
		handleSelectionChange(val) {
			this.multipleSelection = val;
			if (this.checkAll == 2) {
				this.openNumber = this.totalNum;
			} else {
				this.openNumber = this.multipleSelection.length;
			}
		},
		// 是否全选数据处理
		allIdChange() {
			var arr = [];
			this.multipleSelection.forEach((val, index, val_arr) => {
				arr.push(val.id)
			});
			if (this.checkAll == 2) {
				this.tableIds = 'checkAll'
			} else {
				this.tableIds = arr.join();
			}
			console.log(this.tableIds)
		},
		// 新增
		newAdd() {
			this.$router.push({
				path: "/brandPartyAdd"
			});
		},
		// 批量编辑
		batchEditor() {

		},
		// 下载
		downData() {
			this.downLoading = true
			let params = {}
			if (this.platform) {
				params.platform = this.platform
			}
			if (this.shopname) {
				params.shopname = this.shopname
			}
			if (this.productname) {
				params.productname = this.productname
			}
			if (this.status || this.status == 0) {
				params.status = this.status
			}
			if (this.timeDate && this.timeDate.length != 0) {
				params.starttime = this.timeDate[0] + ' 00:00:00'
				params.endtime = this.timeDate[1] + ' 23:59:59'
			}
			fetch({
				url: "hcm/campaignSettingprice/exportExcelgetCampaignSettingprice",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "blob"
			})
				.then((res) => {
					//下载
					let url = window.URL.createObjectURL(new Blob([res]))
					let link = document.createElement('a')
					link.style.display = 'none'
					link.href = url
					link.setAttribute('download', '品牌方活动价格.xlsx')
					document.body.appendChild(link)
					link.click()
					this.downLoading = false
				})
		},
		// 批量导入
		batchImport() {
			this.batchShow = true
		},
	},
}
</script>


<style lang='scss'>
#dialog {
	.el-button--primary {
		color: #FFF;
		background-color: #bda571;
		border-color: #bda571;
	}

	.el-button--primary:hover {
		color: #FFF;
		background-color: #c0ae8a;
		border-color: #c0ae8a;
	}
}

.el-table th {
	background-color: #f3f7ff !important;
}

.brandPartyPage {
	padding: 20px;
	background-color: white;
	min-height: 600px;
	border-radius: 12px;
}

.downBtn {
	margin-bottom: 5px;
}

.prompt {
	height: 28px;
	border: 1px solid #108cee;
	background-color: #e6f7ff;
	border-radius: 5px;
	line-height: 28px;
	margin-top: 8px;
	margin-bottom: 8px;
}

.promptFont {
	color: #108cee;
	font-size: 14px;
	margin-left: 3px;
	margin-right: 3px;
}

.promptFont2 {
	color: #108cee;
	font-size: 14px;
	margin-left: 3px;
	margin-right: 3px;
	cursor: pointer;
}
</style>
